module.exports = __webpack_public_path__ + "img/record-empty.36bd134b.svg";